<template>
  <div v-click-outside="closeOptions" class="filters-zone" @click="closeOptions">
    <div class="filters-zone__buttons">
      <div class="filters-zone__shortcuts">
        <slot name="shortcuts" />
      </div>
      <slot name="buttons" />
      <button
        v-if="!noOptionsButton"
        class="filters-zone__button generic-border generic-border--small-text-btn"
        @click.stop="openOptions"
      >
        <Icon>{{ options }}</Icon>
        <span>{{ $t('message.OPTIONS') }}</span>
      </button>
    </div>
    <SlideFadeModal
      ref="modal"
      class="filters-zone__modal"
      :class="customModalClass"
      :displayed="isOpen"
      @outsideClick="closeOptions"
    >
      <div v-if="isOpen" class="filters-zone__content generic-border" @click.stop="">
        <div v-if="modalTitle !== ''" class="filters-zone__modal__title">
          <h1 class="basic-blue-title">
            {{ modalTitle }}
          </h1>
        </div>
        <div v-if="modalTitle !== ''" class="filters-zone__modal__sep filters-zone__modal__sep--no-top-margin" />
        <slot />
      </div>
    </SlideFadeModal>
  </div>
</template>

<script>

/**
 * Component used to display page filters and options.
 */

// Components
import Icon from '@/components/icon.vue';
import SlideFadeModal from '@/components/edition-modals/slide-fade-modal.vue';
// Utils and assets
import { options } from '@/assets/icons';

export default {

  name: 'FiltersZone',

  components: {
    Icon,
    SlideFadeModal,
  },

  props: {
    displayed: Boolean,
    forceOpen: Boolean,
    disabled: Boolean,
    disableClickOutside: Boolean,
    noOptionsButton: Boolean,
    modalTitle: {
      type: String,
      default: '',
    },
    customModalClass: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      options,
      isOpen: this.displayed,
    };
  },

  watch: {
    forceOpen() {
      this.isOpen = this.forceOpen;
    },
  },

  mounted() {
    this.documentBody.appendChild(this.$refs.modal.$el);
  },

  beforeDestroy() {
    if (this.$refs.modal && this.$refs.modal.$el) {
      this.$refs.modal.$el.remove();
    }
  },

  methods: {
    openOptions() {
      if (this.disabled) {
        return;
      }
      this.isOpen = true;
      this.$emit('open');
    },
    /** Close the options panel. Used in IshikawaEditionModal */
    closeOptions() {
      if (this.disabled) {
        return;
      }
      if (!this.disableClickOutside) {
        this.isOpen = false;
        this.$emit('close');
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.filters-zone {
  position: relative;
  z-index: 10003;

  &__buttons {
    height: $filters-zone-height;
    background: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.7rem;
  }

  &__modal.slide-fade-modal {
    z-index: 10003;

    .slide-fade-modal__content {
      width: 25%;
      margin-left: 75%;
      padding: 0 1.4rem;
    }

    h2.basic-sub-title {
      margin: 1rem 0 0 0;
      padding: 1rem 0;

      &:after {
        content: " ";
        display: block;
        background: $color-gray-background-hover;
        height: 1px;
        transform: translateY(1rem);
        margin: 0 -1.4rem 1rem -1.4rem;
      }
    }

    h1.basic-blue-title, h2.basic-sub-title {
      text-align: left;
    }

    h1.basic-blue-title {
      padding: 0px;
      background: transparent;
    }

    .filters-zone__modal__title {
      padding: 1rem 0;
    }

    .filters-zone__modal__sep {
      height: 1px;
      background: $color-gray-background-hover;
      margin: 1rem -1.4rem;

      &--no-top-margin {
        margin-top: 0px;
      }
    }
  }

  & &__sep {
    background-color: $color-gray-background;
    margin: 1rem -1.4rem;
    height: 1px;
  }

  &__content {
    > *:last-child {
      margin-bottom: 10rem;
    }
  }
}

@media (max-width: $smartphone-landscape) {
  .filters-zone {

    &__buttons {
      height: $smartphone-filters-zone-height;
    }

    &__modal.slide-fade-modal {

      .slide-fade-modal__content {
        width: 75%;
        margin-left: 25%;
      }
    }
  }
}
</style>
